import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { App } from 'antd'
import { useTranslation } from 'react-i18next'
import { contextCompanyIdSelector } from '../../../redux/context/company/selectors'
import budgetDriversQueryKeys from './budgetDriversQueryKeys'
import { BudgetDriver } from '../../../types/budgetDriver/BudgetDriver'
import { createBudgetDriver } from '../service/budgetDriversService'

export const useCreateBudgetDriver = () => {
  const companyId = useSelector(contextCompanyIdSelector)
  const queryClient = useQueryClient()
  const { t } = useTranslation()
  const { message } = App.useApp()

  if (!companyId) {
    throw new Error('Company ID is required for budget drivers.')
  }

  return useMutation({
    mutationKey: ['budget', 'budgetDriver', 'create'],
    mutationFn: (data: BudgetDriver) => createBudgetDriver(data, companyId),
    onSuccess() {
      message.success(t('messages:createSuccess', 'Created successfully'))
      queryClient.invalidateQueries({ queryKey: budgetDriversQueryKeys.list({ companyId }) })
    },
    onError(error) {
      message.error(error.message || t('messages:createError', 'Failed to create'))
    }
  })
}
